import { get, post, put, del } from '../lib/apiClient';

export const uploadRequest = (payload) => post('/videos/upload-request', payload);

export const uploadComplete = (payload) => post('/videos/upload-complete', payload);

export const listVideos = (query) => get('/videos', { query });

export const getVideo = (videoId) =>
  get(`/videos/${encodeURIComponent(videoId)}`);

export const updateVideo = (videoId, payload) =>
  put(`/videos/${encodeURIComponent(videoId)}`, payload);

export const deleteVideo = (videoId) =>
  del(`/videos/${encodeURIComponent(videoId)}`);

export const watchVideo = (videoId) =>
  post(`/videos/${encodeURIComponent(videoId)}/watch`);

export const createPlaylist = (payload) => post('/playlists', payload);

export const listPlaylists = (query) => get('/playlists', { query });

export const getPlaylist = (playlistId) =>
  get(`/playlists/${encodeURIComponent(playlistId)}`);

export const updatePlaylist = (playlistId, payload) =>
  put(`/playlists/${encodeURIComponent(playlistId)}`, payload);

export const deletePlaylist = (playlistId) =>
  del(`/playlists/${encodeURIComponent(playlistId)}`);

export async function uploadVideo(file) {
  const { uploadUrl, videoId } = await uploadRequest({
    fileName: file.name,
    fileSize: file.size,
    mimeType: file.type || 'video/mp4',
  });
  const putResponse = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type || 'video/mp4' },
    body: file,
  });
  if (!putResponse.ok) {
    throw new Error(`S3 upload failed (HTTP ${putResponse.status})`);
  }
  return uploadComplete({ videoId });
}
